<div>
  <!-- <img
    *ngIf="isDarkMode === false"
    src="../../../../assets/images/logo-22.png"
    alt="img"
    class="mx-auto w-36 animate__animated animate__backInDown animate__delay-1s"
  />
  <img
    *ngIf="isDarkMode === true"
    src="../../../../assets/images/logo-23.png"
    alt="img"
    class="mx-auto w-36 animate__animated animate__backInDown animate__delay-1s"
  /> -->
  <div class="panel text-black dark:text-white">
    <div class="mb-5">
      <div class="mb-4 flex flex-col items-center justify-center sm:flex-row sm:justify-between animate__animated animate__backInDown animate__delay-1s">
        <div class="mb-4 sm:mb-0">
          <div class="text-center text-lg font-semibold ltr:sm:text-left rtl:sm:text-right">Calendario</div>
          <!-- <div class="mt-2 flex flex-wrap items-center justify-center sm:justify-start">
                        <div class="flex items-center ltr:mr-4 rtl:ml-4">
                            <div class="h-2.5 w-2.5 rounded-sm text-black dark:text-white bg-primary ltr:mr-2 rtl:ml-2"></div>
                            <div>Tareas</div>
                        </div>
                        <div class="flex items-center ltr:mr-4 rtl:ml-4">
                            <div class="h-2.5 w-2.5 rounded-sm bg-info ltr:mr-2 rtl:ml-2"></div>
                            <div>Citas</div>
                        </div>
                        <div class="flex items-center ltr:mr-4 rtl:ml-4">
                            <div class="h-2.5 w-2.5 rounded-sm bg-success ltr:mr-2 rtl:ml-2"></div>
                            <div>Personal</div>
                        </div>
                        <div class="flex items-center">
                            <div class="h-2.5 w-2.5 rounded-sm bg-green-900 ltr:mr-2 rtl:ml-2"></div>
                            <div>Importante</div>
                        </div>
                    </div> -->
        </div>
        <!-- <button type="button" class="btn btn-primary" (click)="goToAssistant()">
                    <icon-plus class="ltr:mr-2 rtl:ml-2" />
                    Crear Evento
                </button> -->
      </div>
      <div class="calendar-wrapper">
        <full-calendar #calendar [options]="calendarOptions" [deepChangeDetection]="true">
          <ng-template #eventContent let-arg>
            <div class="fc-event-main-frame flex items-center px-1 py-0.5 text-white animate__animated animate__backInDown animate__delay-1s">
              <div class="fc-event-time px-0.5 font-semibold">{{ arg.timeText }}</div>
              <div class="fc-event-title-container flex items-center">
                <div class="fc-event-title fc-sticky px-0.5 !font-medium break-words whitespace-normal w-full">{{ arg.event.title }}</div>
              </div>
            </div>
          </ng-template>
        </full-calendar>
      </div>
    </div>
  </div>
  <!-- modal -->
  <ngx-custom-modal #isAddEventModal class="no-footer">
    <ng-template #modalHeader>
      <div class="">Detalles de la Cita</div>
    </ng-template>
    <ng-template #modalBody>
      <div class="text-sm w-full p-5 border rounded-md bg-center bg-azulOscuro text-white dark:text-white">
        <div class="mb-5 animate__animated animate__flipInY">
          <h3 class="font-semibold mb-2">Información del Taller</h3>
          <ng-container *ngIf="getEventById(params.value.id) as eventObj">
            <div *ngIf="eventObj.extendedProps?.workshop" class="space-y-2">
              <p><span class="font-semibold">Nombre:</span> {{eventObj.extendedProps.workshop.workShopName}}</p>
              <!-- <p><span class="font-semibold">Tipo:</span> {{eventObj.extendedProps.workshop.workShopType}}</p>
                            <p><span class="font-semibold">ID:</span> {{eventObj.extendedProps.workshop.workShopTuulAppId}}</p> -->
            </div>
          </ng-container>
        </div>

        <div class="mb-5 animate__animated animate__flipInY">
          <h3 class="font-semibold mb-2">Información del Vehículo</h3>
          <ng-container *ngIf="getEventById(params.value.id) as eventObj">
            <div *ngIf="eventObj.extendedProps?.user" class="space-y-2">
              <p><span class="font-semibold">Propietario:</span> {{eventObj.extendedProps.user.name}} {{eventObj.extendedProps.user.lastName}}</p>
              <p><span class="font-semibold">Placa:</span> {{eventObj.extendedProps.vehicle.plate}}</p>
              <p><span class="font-semibold">Vehículo:</span> {{eventObj.extendedProps.vehicle.brand}} {{eventObj.extendedProps.vehicle.model}}</p>
              <p><span class="font-semibold">Contacto:</span> {{eventObj.extendedProps.user.phone}} - {{eventObj.extendedProps.user.email}}</p>
            </div>
          </ng-container>
        </div>

        <div class="mb-5 animate__animated animate__flipInY">
          <h3 class="font-semibold mb-2">Detalles de la Cita</h3>
          <ng-container *ngIf="getEventById(params.value.id) as eventObj">
            <div class="space-y-2">
              <p><span class="font-semibold">Fecha:</span> {{eventObj.start | date:'dd/MM/yyyy'}}</p>
              <p><span class="font-semibold">Hora:</span> {{eventObj.start | date:'HH:mm'}}</p>
              <!-- <p><span class="font-semibold">Descripción:</span> {{eventObj.extendedProps.description}}</p> -->
            </div>
          </ng-container>
        </div>

        <div class="mt-8 flex items-center justify-end">
          <button type="button" class="btn btn-outline-danger" (click)="isAddEventModal.close()">Cerrar</button>
        </div>
      </div>
    </ng-template>
  </ngx-custom-modal>
</div>
